import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationIconComponent } from './confirmation-icon.component';

@NgModule({
    declarations: [ConfirmationIconComponent],
    imports: [CommonModule],
    exports: [ConfirmationIconComponent],
})
export class ConfirmationIconModule {}
